import style from "./style.scss";

const Hero = ({ background, children }) => (
  <div class={style.hero} style={`background-image: url('${background}')`}>
    <div class={style.wrapper}>{children}</div>
  </div>
);

export default Hero;
